import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f0ea13bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-container" }

import { ref, computed } from "vue";
import { useRoute } from "vue-router";

import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";
import Button from "primevue/button";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopBrandPanel',
  props: {
    isLoading: { type: Boolean },
    isButtonDisabled: { type: Boolean }
  },
  emits: ["createBrand"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const route = useRoute();

const nameEdit = computed(() => {
  return route.params.id ? "Редактирование" : "Создание";
});

const items = ref([
  { label: "Справочники" },
  { label: "Список брендов", route: "brands" },
  { label: `${nameEdit.value} бренда` },
]);

const createBrand = () => {
  emit("createBrand");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TopPanel, null, {
    default: _withCtx(() => [
      _createVNode(BreadCrumbs, {
        items: items.value,
        class: "s-bread"
      }, null, 8, ["items"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Button), {
          label: "Сохранить бренд",
          class: "segment-save-button m-l-16 m-r-16",
          onClick: createBrand,
          loading: _ctx.isLoading,
          disabled: _ctx.isButtonDisabled
        }, null, 8, ["loading", "disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})